import { isDev } from 'helpers';

(window as any).USE_LOGGER = isDev();

export function logger(...arg: any) {
	if ((window as any).USE_LOGGER) {
		console.log(...arg);
	}
}
